import { render, staticRenderFns } from "./MediaKit.vue?vue&type=template&id=2a7da9a8&scoped=true&"
import script from "./MediaKit.vue?vue&type=script&lang=ts&"
export * from "./MediaKit.vue?vue&type=script&lang=ts&"
import style0 from "./MediaKit.vue?vue&type=style&index=0&id=2a7da9a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7da9a8",
  null
  
)

export default component.exports